module.exports = __webpack_public_path__ + "static/media/buena.d657b89d.svg";